export const TOGGLE_APP_MENU = '@manakin/core/dist/TOGGLE_APP_MENU';

export function toggleAppMenu() {
    return {
        type: TOGGLE_APP_MENU,
        payload: {},
    };
}
